export enum Routes {
  ReportsRouter = '/reports/*',
  ReportsPage = 'reporting',
  InsightsPage = 'ai-insights',
  TemplatesPage = 'templates',
}
